import React, { useEffect, useState } from "react";
import PageHeader from "@/components/PageHeader";
import SEO from "@/components/SEO";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { fetchFaq } from "@/lib/api";

export default function FAQPage() {
    const [items, setItems] = useState([]);
    useEffect(() => {
        fetchFaq().then(setItems).catch(() => {});
    }, []);

    return (
        <div data-testid="faq-page">
            <SEO
                title="FAQ — Moving Mountains Advisors"
                description="Answers to the most common questions about Moving Mountains, Jarvis, our carriers, licensing, and how we get paid."
            />
            <PageHeader
                eyebrow="FAQ"
                title="Questions, answered straight."
                subtitle="If you don't see your question here, reach out — we respond personally."
            />
            <section className="mm-section bg-white">
                <div className="mm-container max-w-3xl">
                    <Accordion type="single" collapsible className="w-full">
                        {items.map((f) => (
                            <AccordionItem
                                key={f.id}
                                value={f.id}
                                className="border-b border-mm-line"
                                data-testid={`faq-item-${f.order}`}
                            >
                                <AccordionTrigger className="text-left text-base sm:text-lg font-medium text-mm-navy">
                                    {f.question}
                                </AccordionTrigger>
                                <AccordionContent className="text-mm-muted leading-relaxed">
                                    {f.answer}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                    {items.length === 0 && (
                        <p className="text-mm-muted">Loading…</p>
                    )}
                </div>
            </section>
        </div>
    );
}
